import React, { useEffect } from 'react';

import { css } from '@emotion/css';
import { Card, CardContent, CardHeader, Theme } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles';
import {
  DiabetesTypeInfo,
  InsulinSchemeInfo,
  TermDateInfo,
} from '@/pages/patient-settings/CurrentCarePlan';
import { Queries } from '@/queries/Queries';

export type TelemonitoringFormProps = {
  patientId: string;
};

type FormType = {
  type: string;
  medicationSchema: string;
  telemonitoringTier: string;
};

export const DiabetesInfo: React.FC<TelemonitoringFormProps> = ({
  patientId,
}) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const carePlans = Queries.practitioner.useCarePlans(patientId);
  const currentCarePlan = carePlans.current_care_plan;

  const fakeForm = useForm<FormType>();
  const condition = Queries.condition.useCondition(patientId);

  useEffect(() => {
    if (currentCarePlan && condition) {
      fakeForm.setValue('type', condition.type);
      fakeForm.setValue('medicationSchema', condition.medicationSchema);
      fakeForm.setValue(
        'telemonitoringTier',
        currentCarePlan.telemonitoringTier,
      );
    }
  }, [fakeForm, currentCarePlan, condition]);

  if (!condition) {
    return null;
  }

  return (
    <Card className={styles.container} elevation={0}>
      <CardHeader
        id="tls-title"
        title={t('pages.patientMedicalFile.diabetes.title')}
      />
      <CardContent className={styles.body}>
        <DiabetesTypeInfo condition={condition} />
        <InsulinSchemeInfo condition={condition} />
        <TermDateInfo condition={condition} />
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  body: css`
    display: flex;
    flex-direction: row;
    gap: max(10%, ${theme.spacing(16)});
    flex-wrap: wrap;
    width: 90%;
  `,
  row: css``,
});
